export default [
  {
    text: 'coupon.table.name',
    value: 'name',
  },
  {
    text: 'coupon.table.code',
    value: 'code',
  },
  {
    text: 'coupon.table.customerGroup',
    value: 'customerGroup',
  },
  {
    text: 'coupon.table.countries',
    value: 'countries',
    type: 'array',
  },
  {
    text: 'coupon.table.states',
    value: 'states',
    type: 'array',
  },
  {
    text: 'coupon.table.venues',
    value: 'venues',
    type: 'slot',
  },
  {
    text: 'coupon.table.active',
    value: 'active',
    type: 'slot',
  },
  {
    text: 'coupon.table.disabled',
    value: 'disabled',
    type: 'slot',
  },
  {
    text: 'coupon.table.from',
    value: 'from',
    type: 'date',
    format: 'DD-MM-YYYY',
  },
  {
    text: 'coupon.table.to',
    value: 'to',
    type: 'date',
    format: 'DD-MM-YYYY',
  },
  {
    text: 'coupon.table.type',
    value: 'type',
  },
  {
    text: 'coupon.table.value',
    value: 'value',
  },
  {
    text: 'coupon.table.mov',
    value: 'mov',
    type: 'slot',
  },
  {
    text: 'coupon.table.amount',
    value: 'amount',
  },
];
